<template>
  <nav class="ui secondary left vertical pointing menu">
    <Spinny :promise="fieldsPromise" />
    <Placy
      v-if="!fields.length"
      :promise="fieldsPromise"
      :empty-message="$t('NO_THING_YET', { thing: $tc('FIELD', 2) })"
      :error-message="$t('ERR', { action: $t('READ', { thing: $tc('FIELD', 2) }) })"
    />

    <router-link
      class="item field"
      :to="{ name: 'app-field', params: { appId: $route.params.appId, fieldId: field.id } }"
      :active-class="'active'"
      v-for="field in fieldsByName"
      :key="field.id"
    >
      <span class="text">{{ field.name }}</span>
      <span class="actions">
        <span
          href
          @click.prevent="selectFieldAction(field, action)"
          class="ui label"
          v-for="action in field.actions"
          :key="action"
        >
          {{ action }}
        </span>
      </span>
    </router-link>

    <router-link
      class="item bottom new"
      :to="{ name: 'new-field', params: { appId: $route.params.appId } }"
    >
      <button class="ui right labeled icon button">
        <i class="plus icon"></i>
        {{ $t('NEW', { thing: $tc('FIELD', 1) }) }}
      </button>
    </router-link>
  </nav>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../../scss/variables';

.ui.secondary.vertical.pointing.menu {
  min-width: 16rem;
  margin: 0 0 0 auto;
  height: auto;

  &:before {
    left: 1px;
  }

  .item.field {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .text {
      padding-right: $gs/3;
      margin: $gs/2 0; // only if actions are underneath (long name)
    }

    .actions {
      display: flex;
      flex-wrap: wrap;
      flex-basis: 50%;
      flex-grow: 1;
      flex-shrink: 1;
      justify-content: flex-end;

      .label {
        width: 50%;
        max-width: 63px; // for a consistent look
        border: 1px solid whitesmoke;
        margin: 0;
        text-align: center;
        flex-basis: 100%;

        &:hover,
        &:focus {
          background-color: $g7;
        }
      }
    }
  }

  .bottom.new {
    .button {
      width: 100%;
    }
  }
}
</style>

<script>
// @flow
import _ from 'lodash'
import Vue from 'vue'
import { Spinny, Placy } from 'ui'
import { Field, Toast, Typenames } from 'services'
import { map, catchError } from 'rxjs/operators'
import { ActionTypes } from 'store'
export default {
  name: 'field-list',
  components: { Spinny, Placy },

  props: {
    fieldActionSelectHandler: {
      type: Function
    }
  },

  data() {
    return {
      fieldsPromise: null
    }
  },

  computed: {
    fields() {
      return this.$store.state.field.items
    },
    fieldsByName() {
      return _.orderBy(this.fields, 'name')
    },
    appId() {
      return this.$route.params.appId
    }
  },

  methods: {
    selectFieldAction(field, action) {
      this.fieldActionSelectHandler(field, action)
    }
  },
  created() {
    this.fieldsPromise = Field.readFields()
  }
}
</script>
